import React, { useState, useRef, useContext } from "react";
import { Link, Element } from "react-scroll";
import "./Menu.css";
import { IoSearchSharp } from "react-icons/io5";
import NavBar from "./NavBar";
import ProductContext from "../ProductContext";

const Menu = () => {  
  const { products, categories, loading, settings } = useContext(ProductContext);
  const [quantities, setQuantities] = useState({});  
  const [searchQuery, setSearchQuery] = useState("");
  const [modalImage, setModalImage] = useState(null); // Estado para a imagem no modal
  const menuNavRef = useRef(null);  
  const menuData = products 
  
  const handleSetActive = (categoryName) => {
    const menuNav = menuNavRef.current;
    const activeLink = menuNav.querySelector(`[data-category="${categoryName}"]`);
    if (menuNav && activeLink) {
      const offsetLeft = activeLink.offsetLeft;
      const offsetWidth = activeLink.offsetWidth;
      const containerWidth = menuNav.offsetWidth;
      menuNav.scrollLeft = offsetLeft - containerWidth / 2 + offsetWidth / 2;
    }
  };

  const updateQuantity = (id, delta) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) + delta),
    }));
  };

  const totalAmount = Object.entries(quantities).reduce((total, [id, qty]) => {
    const item = menuData.find((item) => item._id === id);
    return total + (item ? item.price * qty : 0);
  }, 0);

  const filteredMenuData = menuData.filter(
    (item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      categories.find(
        (category) =>
          category.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
          category.name === item.category
      )
  );

  const filteredCategories = categories.filter(
    (category) =>
      //category.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      filteredMenuData.some((item) => item.category === category.name)
  );

  const clearSearch = () => {
    setSearchQuery("");
  };

  const openImageModal = (image) => {
    setModalImage(image); // Define a imagem para o modal
  };

  const closeImageModal = () => {
    setModalImage(null); // Fecha o modal
  };

  return (
    <div className="menu-container">
      {/* Capa com Logo */}
      <div className="menu-header">
        <NavBar />
        {settings.cover && (
          <img
            className="menu-cover"
            src={`https://cardapio.olympicbarbacena.com.br${settings.cover}`}
            alt="Capa do Cardápio"
          />
        )}
        {settings.logo && (
          <img
            className="menu-logo"
            src={`https://cardapio.olympicbarbacena.com.br${settings.logo}`}
            alt="Logo"
          />
        )}
      </div>

      {/* Loading */}
      {loading ? <p>Carregando cardápio...</p> : null}

      {/* Menu de Categorias */}
      {!loading && (
        <nav className="menu-nav" ref={menuNavRef}>
          {filteredCategories.map((category) => (
            <Link
              key={category._id}
              to={category.name}
              spy={true}
              smooth={true}
              duration={500}
              offset={-50}
              className="menu-nav-link"
              activeClass="active"
              data-category={category.name}
              onSetActive={() => handleSetActive(category.name)}
            >
              {category.name}
            </Link>
          ))}
        </nav>
      )}

      {/* Barra de Busca */}
      {!loading && (
        <div className="menu-search">
          <IoSearchSharp className="busca" />
          <input
            type="text"
            placeholder="Buscar produto"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="menu-search-input"
          />
          {searchQuery && (
            <button onClick={clearSearch} className="menu-search-clear">
              ✖
            </button>
          )}
        </div>
      )}

      {/* Produtos por Categoria */}
      {!loading &&
        filteredCategories.map((category) => (
          <Element
            key={category._id}
            name={category.name}
            className="menu-section"
          >
            <h3 className="menu-category-title">{category.name}</h3>
            {filteredMenuData
              .filter((item) => item.category === category.name)
              .map((item) => (
                <div
                  className={`menu-item ${!item.inStock ? "out-of-stock" : ""}`}
                  key={item._id}
                >
                  {item.image && (
                    <img
                      src={`https://cardapio.olympicbarbacena.com.br${item.image}`}
                      alt={item.name}
                      className="menu-item-image"
                      onClick={() =>
                        openImageModal(
                          `https://cardapio.olympicbarbacena.com.br${item.image}`
                        )
                      }
                    />
                  )}
                  {!item.image && (
                    <img
                      src={
                        "https://cardapio.olympicbarbacena.com.br/uploads/1737063857910.png"
                      }
                      alt={item.name}
                      className="menu-item-image"
                      onClick={() =>
                        openImageModal(
                          "https://cardapio.olympicbarbacena.com.br/uploads/1737063857910.png"
                        )
                      }
                    />
                  )}
                  <div className="menu-item-info">
                    <h3>{item.name}</h3>
                    <p>{item.description}</p>
                  </div>
                  <div className="menu-quantity">
                    <button onClick={() => updateQuantity(item._id, -1)}>
                      -
                    </button>
                    <input
                      type="text"
                      value={quantities[item._id] || 0}
                      readOnly
                    />
                    <button onClick={() => updateQuantity(item._id, 1)}>
                      +
                    </button>
                  </div>
                  <div className="menu-price">
                    R$ {item.price ? item.price.toFixed(2) : "Indisponível"}
                  </div>
                </div>
              ))}
          </Element>
        ))}

      {/* Modal de Imagem */}
      {modalImage && (
        <div className="modal-overlay" onClick={closeImageModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-button" onClick={closeImageModal}>
              ✖
            </button>
            <img
              src={modalImage}
              alt="Imagem Ampliada"
              className="modal-image"
            />
          </div>
        </div>
      )}

      {/* Menu fixo */}
      <div className="menu-footer">
        <div className="menu-total">
          Total: <span>R$ {totalAmount.toFixed(2)}</span>
        </div>
        <button className="menu-submit-button">ENVIAR PEDIDO</button>
      </div>
    </div>
  );
};

export default Menu;
